import { REQUESTS_BY_CLIENT_FILTERS_FAILURE, REQUESTS_BY_CLIENT_FILTERS_REQUEST, REQUESTS_BY_CLIENT_FILTERS_SUCCESS, RequestsByClientFiltersActionTypes, RequestsByClientFiltersState } from './types';

const defaultState: RequestsByClientFiltersState = {
  isLoading: false,
  errorMessage: '',
};

function requestsByClientFilters(state = defaultState, action: RequestsByClientFiltersActionTypes): RequestsByClientFiltersState {
  switch (action.type) {
    case REQUESTS_BY_CLIENT_FILTERS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case REQUESTS_BY_CLIENT_FILTERS_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: '',
      };
    case REQUESTS_BY_CLIENT_FILTERS_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: '',
      };
    default:
      return state;
  }
}

export default requestsByClientFilters;
